import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpModule } from '@angular/http';
import { WebServiceService } from './shared/services/web-service.service';
import { IrFieldsService } from './shared/services/ir-fields.service';
import { PoDataTransferServiceService } from './shared/services/po-data-transfer-service.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToasterModule, ToasterService } from 'angular2-toaster';
import { AppToasterService } from './shared/services/app-toaster.service';
import { HttpErrorHandlerService } from './shared/services/http-error-handler.service';
import { AppComponent } from './app.component';
import { ExcelService } from './shared/services/excel/excel.service';
import { AuthGuardService } from './shared/services/auth-guard.service';
import { LocalStorageService } from './shared/services/storage/local-storage.service';
import { AppRoutingModule } from './app-routing.module';
import { ChartsModule } from 'ng2-charts';
import { CompanySetupService } from './shared/services/company-setup.service';
import { EesDesService } from './shared/services/ees-des.service';
import { TabTrackingService } from './shared/services/tab-tracking.service';
import { LogoutService } from './shared/services/logout.service';
import { CheckActivityService } from './shared/services/check-activity.service';
import { GlobalRequestManagerService } from './shared/services/global-request-manager.service';
import { MAT_DATE_LOCALE } from '@angular/material';
import { CookieService } from 'ngx-cookie-service';
import { FormsModule } from '@angular/forms';
import { ChatbotModule } from './shared/components/chatbot/chatbot.module';
import { DataService } from './shared/services/data-sharing/data.service';
import { RuntimeConfigService } from './shared/services/runtime-config.service';
import { CommonFunctioModule } from './common/commonFunction.module';
import { CompanyLicenseLoginService } from './shared/services/company-license-login.service';
import { MultiCompanyViewTokenService } from './shared/services/multi-company-view-token.service';
import { GroupMailedInvoiceCompanyContextService } from './shared/services/group-mailed-invoice-company-context.service';

export function initializeRuntimeConfig(runtimeConfigService: RuntimeConfigService) {
  return () => runtimeConfigService.load();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    ToasterModule.forRoot(),
    ChartsModule,
    AppRoutingModule,
    FormsModule,
    ChatbotModule,
    CommonFunctioModule
  ],
  exports: [],
  providers: [
    ExcelService,
    PoDataTransferServiceService,
    WebServiceService,
    IrFieldsService,
    CompanySetupService,
    AuthGuardService,
    LocalStorageService,
    EesDesService,
    TabTrackingService,
    LogoutService,
    CheckActivityService,
    GlobalRequestManagerService,
    CookieService,
    DataService,
    RuntimeConfigService,
    HttpErrorHandlerService,
    CompanyLicenseLoginService,

    { provide: ToasterService, useClass: AppToasterService },
    MultiCompanyViewTokenService,
    GroupMailedInvoiceCompanyContextService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeRuntimeConfig,
      deps: [RuntimeConfigService],
      multi: true
    },
    {provide: MAT_DATE_LOCALE, useValue: window.localStorage.getItem('localDate')?window.localStorage.getItem('localDate'):'en-US'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// /codebuild/output/src2657079836/src/src/app/app.module.ts